export function columnsInOrder<T extends { key: unknown }>(source: T[], orderedKeys: string[] | null): T[] {
  if (!orderedKeys?.length) return source
  const byKey = new Map(source.map((column) => [String(column.key), column]))
  const ordered = orderedKeys.flatMap((key) => {
    const column = byKey.get(String(key))
    if (!column) return []
    byKey.delete(String(key))
    return [column]
  })
  return [...ordered, ...byKey.values()]
}

export function restoreColumnOrderFromMove(currentKeys: string[], oldIndex: unknown, newIndex: unknown): string[] {
  const from = Number(oldIndex)
  const to = Number(newIndex)
  if (!Number.isInteger(from) || !Number.isInteger(to) || to < 0 || to >= currentKeys.length) {
    return [...currentKeys]
  }

  const restored = [...currentKeys]
  const [moved] = restored.splice(to, 1)
  restored.splice(from, 0, moved)
  return restored
}
